import { render, staticRenderFns } from "./detailsNav.vue?vue&type=template&id=d39fd568&scoped=true"
import script from "./detailsNav.vue?vue&type=script&lang=ts"
export * from "./detailsNav.vue?vue&type=script&lang=ts"
import style0 from "./detailsNav.vue?vue&type=style&index=0&id=d39fd568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39fd568",
  null
  
)

export default component.exports